import { render, staticRenderFns } from "./LokLokText.vue?vue&type=template&id=290594f5&"
import script from "./LokLokText.vue?vue&type=script&lang=js&"
export * from "./LokLokText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports